import { __decorate, __param } from 'tslib';
import { InjectionToken, Inject, Injector, Injectable, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
function isBlank(obj) {
    return obj === undefined || obj === null;
}
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}
function isString(obj) {
    return typeof obj === 'string';
}
function mergeOptions(oldOptions, newOptions) {
    if (!newOptions) {
        return oldOptions;
    }
    return {
        path: isPresent(newOptions.path) ? newOptions.path : oldOptions.path,
        domain: isPresent(newOptions.domain) ? newOptions.domain : oldOptions.domain,
        expires: isPresent(newOptions.expires) ? newOptions.expires : oldOptions.expires,
        secure: isPresent(newOptions.secure) ? newOptions.secure : oldOptions.secure,
        httpOnly: isPresent(newOptions.httpOnly) ? newOptions.httpOnly : oldOptions.httpOnly
    };
}
function safeDecodeURIComponent(str) {
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
}
function safeJsonParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
}

const COOKIES_OPTIONS = new InjectionToken('COOKIES_OPTIONS');
let CookiesOptionsService = class CookiesOptionsService {
    constructor(options = {}, injector) {
        this.injector = injector;
        this.defaultOptions = {
            path: this.injector.get(APP_BASE_HREF, '/'),
            domain: null,
            expires: null,
            secure: false
        };
        this._options = mergeOptions(this.defaultOptions, options);
    }
    get options() {
        return this._options;
    }
};
CookiesOptionsService.ɵfac = function CookiesOptionsService_Factory(t) { return new (t || CookiesOptionsService)(ɵngcc0.ɵɵinject(COOKIES_OPTIONS), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CookiesOptionsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CookiesOptionsService, factory: function (t) { return CookiesOptionsService.ɵfac(t); } });
CookiesOptionsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [COOKIES_OPTIONS,] }] },
    { type: Injector }
];
CookiesOptionsService = __decorate([ __param(0, Inject(COOKIES_OPTIONS))
], CookiesOptionsService);

let CookiesService = class CookiesService {
    constructor(cookiesOptions) {
        this.options = cookiesOptions.options;
    }
    put(key, value, options) {
        this.cookiesWriter()(key, value, options);
    }
    putObject(key, value, options) {
        this.put(key, JSON.stringify(value), options);
    }
    get(key) {
        return this.cookiesReader()[key];
    }
    getObject(key) {
        const value = this.get(key);
        return value ? safeJsonParse(value) : value;
    }
    getAll() {
        return this.cookiesReader();
    }
    remove(key, options) {
        this.cookiesWriter()(key, undefined, options);
    }
    removeAll() {
        const cookies = this.getAll();
        Object.keys(cookies).forEach(key => {
            this.remove(key);
        });
    }
    cookiesReader() {
        return {};
    }
    cookiesWriter() {
        return () => { };
    }
};
CookiesService.ɵfac = function CookiesService_Factory(t) { return new (t || CookiesService)(ɵngcc0.ɵɵinject(CookiesOptionsService)); };
CookiesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CookiesService, factory: function (t) { return CookiesService.ɵfac(t); } });
CookiesService.ctorParameters = () => [
    { type: CookiesOptionsService }
];

let ServerCookiesService = class ServerCookiesService extends CookiesService {
    constructor(cookiesOptions, request, response) {
        super(cookiesOptions);
        this.request = request;
        this.response = response;
        this.newCookies = {};
    }
    cookiesReader() {
        const allCookies = Object.assign(Object.assign({}, this.request.cookies), this.newCookies);
        const cookies = {};
        for (const name in allCookies) {
            if (typeof allCookies[name] !== 'undefined') {
                cookies[name] = decodeURIComponent(allCookies[name]);
            }
        }
        return cookies;
    }
    cookiesWriter() {
        return (name, value, options) => {
            this.newCookies[name] = value;
            this.response.cookie(name, value, this.buildCookiesOptions(options));
        };
    }
    buildCookiesOptions(options) {
        const opts = mergeOptions(this.options, options);
        if (isString(opts.expires)) {
            opts.expires = new Date(opts.expires);
        }
        return opts;
    }
};
ServerCookiesService.ɵfac = function ServerCookiesService_Factory(t) { return new (t || ServerCookiesService)(ɵngcc0.ɵɵinject(CookiesOptionsService), ɵngcc0.ɵɵinject('REQUEST'), ɵngcc0.ɵɵinject('RESPONSE')); };
ServerCookiesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServerCookiesService, factory: function (t) { return ServerCookiesService.ɵfac(t); } });
ServerCookiesService.ctorParameters = () => [
    { type: CookiesOptionsService },
    { type: undefined, decorators: [{ type: Inject, args: ['REQUEST',] }] },
    { type: undefined, decorators: [{ type: Inject, args: ['RESPONSE',] }] }
];
ServerCookiesService = __decorate([ __param(1, Inject('REQUEST')),
    __param(2, Inject('RESPONSE'))
], ServerCookiesService);

var ServerCookiesModule_1;
let ServerCookiesModule = ServerCookiesModule_1 = class ServerCookiesModule {
    static forRoot(options = {}) {
        return {
            ngModule: ServerCookiesModule_1,
            providers: [
                { provide: COOKIES_OPTIONS, useValue: options },
                CookiesOptionsService,
                { provide: CookiesService, useClass: ServerCookiesService }
            ]
        };
    }
};
ServerCookiesModule.ɵfac = function ServerCookiesModule_Factory(t) { return new (t || ServerCookiesModule)(); };
ServerCookiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ServerCookiesModule });
ServerCookiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let BrowserCookiesService = class BrowserCookiesService extends CookiesService {
    constructor(cookiesOptions) {
        super(cookiesOptions);
    }
    get cookieString() {
        return document.cookie || '';
    }
    set cookieString(val) {
        document.cookie = val;
    }
    cookiesReader() {
        let lastCookies = {};
        let lastCookieString = '';
        let cookiesArray;
        let cookie;
        let i;
        let index;
        let name;
        const currentCookieString = this.cookieString;
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookiesArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookiesArray.length; i++) {
                cookie = cookiesArray[i];
                index = cookie.indexOf('=');
                if (index > 0) { // ignore nameless cookies
                    name = safeDecodeURIComponent(cookie.substring(0, index));
                    if (isBlank((lastCookies)[name])) {
                        const cookieValue = safeDecodeURIComponent(cookie.substring(index + 1));
                        // Ignore cookies stored with value 'undefined'
                        if (!isBlank(cookieValue) && cookieValue !== 'undefined') {
                            (lastCookies)[name] = cookieValue;
                        }
                    }
                }
            }
        }
        return lastCookies;
    }
    cookiesWriter() {
        return (name, value, options) => {
            this.cookieString = this.buildCookieString(name, value, options);
        };
    }
    buildCookieString(name, value, options) {
        const opts = mergeOptions(this.options, options);
        let expires = opts.expires;
        if (isBlank(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
        }
        if (isString(expires)) {
            expires = new Date(expires);
        }
        let str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? ';path=' + opts.path : '';
        str += opts.domain ? ';domain=' + opts.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += opts.secure ? ';secure' : '';
        const cookiesLength = str.length + 1;
        if (cookiesLength > 4096) {
            console.log(`Cookie \'${name}\' possibly not set or overflowed because it was too
      large (${cookiesLength} > 4096 bytes)!`);
        }
        return str;
    }
};
BrowserCookiesService.ɵfac = function BrowserCookiesService_Factory(t) { return new (t || BrowserCookiesService)(ɵngcc0.ɵɵinject(CookiesOptionsService)); };
BrowserCookiesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BrowserCookiesService, factory: function (t) { return BrowserCookiesService.ɵfac(t); } });
BrowserCookiesService.ctorParameters = () => [
    { type: CookiesOptionsService }
];

var BrowserCookiesModule_1;
let BrowserCookiesModule = BrowserCookiesModule_1 = class BrowserCookiesModule {
    static forRoot(options = {}) {
        return {
            ngModule: BrowserCookiesModule_1,
            providers: [
                { provide: COOKIES_OPTIONS, useValue: options },
                CookiesOptionsService,
                { provide: CookiesService, useClass: BrowserCookiesService }
            ]
        };
    }
};
BrowserCookiesModule.ɵfac = function BrowserCookiesModule_Factory(t) { return new (t || BrowserCookiesModule)(); };
BrowserCookiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BrowserCookiesModule });
BrowserCookiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookiesOptionsService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [COOKIES_OPTIONS]
            }] }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookiesService, [{
        type: Injectable
    }], function () { return [{ type: CookiesOptionsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerCookiesService, [{
        type: Injectable
    }], function () { return [{ type: CookiesOptionsService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['REQUEST']
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['RESPONSE']
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerCookiesModule, [{
        type: NgModule
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserCookiesService, [{
        type: Injectable
    }], function () { return [{ type: CookiesOptionsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserCookiesModule, [{
        type: NgModule
    }], null, null); })();

/*
 * Public API Surface of ngx-utils-cookies-port
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BrowserCookiesModule, CookiesService, ServerCookiesModule, COOKIES_OPTIONS as ɵa, CookiesOptionsService as ɵb, ServerCookiesService as ɵc, BrowserCookiesService as ɵd };

